<section class="table-card">
  <header class="table-header">
    <h3 class="table-title">{{ title }}</h3>
  </header>

  <div class="table-wrap">
    <table class="table">
      <thead>
        <tr>
          <th>Category</th>
          <th>Contract Range</th>
          <th>Registration Fee</th>
          <th>Vendors</th>
          <th class="text-right">Revenue</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <td class="font-medium">{{ row.category }}</td>
          <td>{{ row.contractRange }}</td>
          <td>{{ formatCurrency(row.registrationFee) }}</td>
          <td>{{ row.vendors }}</td>
          <td class="text-right font-semibold">{{ formatCurrency(row.revenue) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

